<script>
    export default {
        name: '',
        prop: {},
        data () {
            return {};
        },
        methods: {},
        components: {},
        mounted () {
        }
    };
</script>

<template>
    <div class="widget-footer">
        广东省人民政府办公厅主办
    </div>
</template>

<style scoped lang="less">
    .widget-footer {
        .px2rem(padding-bottom, 40);
        .px2rem(font-size, 28);
        text-align: center;
        color: #BCBEC2;
    }
</style>
